var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsupgreyimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66546 6.37831C8.99129 5.36752 9.15633 4.48281 9.15633 3.71994C9.15633 2.02065 8.49121 0.710938 7.3855 0.710938C6.78554 0.710938 6.59996 1.06865 6.36762 1.9484C6.37967 1.90235 6.25217 2.39748 6.21533 2.52994C6.14379 2.78494 6.01912 3.21702 5.84204 3.8269C5.83723 3.84319 5.83007 3.8587 5.82079 3.87294L3.79071 7.05052C3.31034 7.80218 2.60151 8.37991 1.76842 8.69881L0.878041 9.03952C0.605753 9.1438 0.378939 9.34073 0.23747 9.59568C0.0960017 9.85064 0.048934 10.1473 0.104541 10.4335L0.590458 12.9396C0.648426 13.2386 0.79085 13.5147 1.00087 13.7353C1.21089 13.9558 1.4797 14.1116 1.7755 14.1841L7.61925 15.6164C8.48064 15.8274 9.39052 15.6898 10.151 15.2335C10.9115 14.7772 11.461 14.0391 11.6801 13.1797L12.795 8.80719C12.8683 8.5196 12.8749 8.21908 12.8143 7.92856C12.7537 7.63804 12.6276 7.36521 12.4455 7.13088C12.2633 6.89656 12.0301 6.70695 11.7635 6.57652C11.497 6.44609 11.2041 6.3783 10.9073 6.37831H8.66546V6.37831Z",
    fill: "#68717A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupgreyimg);
export default __webpack_public_path__ + "static/media/thumbsupgreyimg.d3f08b10102cffe5e1b072ef35ec2733.svg";
export { ForwardRef as ReactComponent };